<template>
    <tr>
        <td>
            {{ row.name }}
            <template v-if="row.name_alternate && row.name != row.name_alternate">
                <br>{{ row.name_alternate }}
            </template>
            <template v-if="row.indeed_url">
                <br><small><a :href="row.indeed_url">{{ row.indeed_url }}</a></small>
            </template>
            <template v-if="row.intelliapp_url">
                <br><small><a :href="row.intelliapp_url">{{ row.intelliapp_url }}</a></small>
            </template>
        </td>
        <td>{{ row.usdot }}</td>
        <td>{{ row.truck_count }}</td>
        <td>{{ row.scraper_jobs }}</td>
        <td>{{ row.indeed_reviews }}</td>
        <td>{{ row.last_activity }}</td>
        <td>
            <template v-if="row.employer_id">
                <a :href="url('admin/employer/' + row.employer_id +'/budgets')">Open Employer</a>
            </template>
        </td>
        <td>
            <template v-if="row.status">
                {{ row.status }}
            </template>
        </td>
        <td>
            <a href="#" @click.prevent="show_modal = true">Detail</a>

            <prospect-detail 
                v-if="show_modal"
                :prospect_id="row.id" 
                @closed="show_modal=false"
            />
        </td>
    </tr>
</template>

<script>
import ProspectDetail from "./prospect-detail";

export default {
    components: {
        ProspectDetail
    },
    props: {
        row: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            show_modal: false,
        };
    },
}
</script>